import ApiService from "./api.service";
export default class PromotionService extends ApiService {
    static base_url = `${super.base_url}/promotions`;
}
